import { comma } from '../utils'

export default function currency(value) {
  // https://caniuse.com/?search=Intl
  // 因為前台瀏覽器相容要求較高，先簡單寫死格式取代 Intl
  return `$${comma(value)}`
}
